import { DESKTOP_BREAKPOINT } from '../config';

export const isMobileDevice = () => {
    if (window.matchMedia) {
        return !window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`).matches;
    }

    return window.innerWidth <= DESKTOP_BREAKPOINT;
};
